/* eslint-disable */
import generateAbsoluteUrl from './generateAbsoluteUrl';

export default function esEspontaneo(prestador) {
  let ret = false;
  const enviroment = generateAbsoluteUrl();
  if (enviroment.includes('pre') || enviroment.includes('clubswiss')) {
    ret = prestador.toString() === '35645' || prestador.toString() === '35646';
  } else if (
    enviroment.includes('localhost') ||
    enviroment.includes('mobileint') ||
    enviroment.includes('srv-php01') ||
    enviroment.includes('srv-php02') ||
    enviroment.includes('mobileqa')
  ) {
    ret = prestador.toString() === '35210' || prestador.toString() === '35211';
  } else {
    ret = prestador.toString() === '35645' || prestador.toString() === '35646';
  }
  return ret;
}



// WEBPACK FOOTER //
// ./src/utils/turnUtils.js